module.exports = __webpack_public_path__ + "media/svg/neutral_light_horizontal-2f05f78b.svg";